import { BreadcrumbData } from '@/entities/breadcrumb/Breadcrumb';
import { GoogleMarkupData, GoogleMarkupDataListElement } from '@/entities/breadcrumb/GoogleMarkupData';

export class GoogleService {
    public generateBreadcrumbMarkupData(breadcrumb: BreadcrumbData): GoogleMarkupData {
        const itemListElements: GoogleMarkupDataListElement[] = breadcrumb.items.map((item, index) => {
            return {
                type: 'ListItem',
                position: index + 1,
                name: item.displayName,
                item: item.url,
            };
        });

        itemListElements.push({
            type: 'ListItem',
            position: itemListElements.length + 1,
            name: breadcrumb.currentPage,
            item: undefined,
        });

        return {
            context: 'https://schema.org',
            type: 'BreadcrumbList',
            itemListElement: itemListElements,
        };
    }

    public stringifyBreadcrumbMarkupData(markupData: GoogleMarkupData): string {
        return `{"@context": "${
            markupData.context
        }", "@type": "BreadcrumbList", "itemListElement": [${markupData.itemListElement
            .map(
                (item) =>
                    `{"@type": "${item.type}", "position": ${item.position}, "name": "${item.name}"${
                        item.item ? `, "item": "${item.item}"` : ''
                    }}`
            )
            .join(', ')}]}`;
    }
}
